/* eslint-disable no-template-curly-in-string */
import R from 'ramda'
import { convertSendDarkTweetFormActionToWidgetAction } from './send-dark-tweet'

const SPEED_THREAD_RESET_WIDGET_TYPE = 'SPEED_THREAD_RESET'
const SPEED_THREAD_RESET_FORM_TYPE = 'Reset Speed Thread'

const isSpeedThreadResetFormType = R.propEq(
  'type',
  SPEED_THREAD_RESET_FORM_TYPE
)

const convertSpeedThreadResetToWidget = R.pipe(
  R.applySpec({
    type: R.always(SPEED_THREAD_RESET_WIDGET_TYPE),
    success: R.pipe(
      convertSendDarkTweetFormActionToWidgetAction,
      successTweet => [successTweet]
    ),
    failure: R.always([])
  })
)

export { isSpeedThreadResetFormType, convertSpeedThreadResetToWidget }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/reset-speed-thread.js